
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import EmployeeRepository from '@/repositories/employees/EmployeeRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class LabelListScreen extends Vue {
    @Inject()
    private readonly employeeRepository!: EmployeeRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.employee.name'),
                align: 'left',
                value: 'name',
                sortable: true,
            },
            {
                text: this.$t('crud.employee.order'),
                value: 'order',
                sortable: true,
            },
        ];
    }
}
